/*eslint-disable no-underscore-dangle*/

// WeakMap method
var privateState = new WeakMap();
function createPrivateState(o){
    privateState.set(o, {});
}
function _private(o){ // "private" is a reserved keyword
    return privateState.get(o);
}

/**
 * EQualOne SDK OnClickManager public APIs
 */
export default class EQOnClickManager {
    constructor(core) {
        createPrivateState(this);
        _private(this).core = core;
    }

    getScripts() {
        return _private(this).core.scriptService.getScripts();
    }

    startScript(key, callback) {
        _private(this).core.scriptService.startScript(parseInt(key), callback, _private(this).core.customFieldsManager.getAll());
    }

    stopScript(key) {
        _private(this).core.scriptService.stopScript(parseInt(key));
    }
}



// WEBPACK FOOTER //
// ./js/public-apis/EQOnClickManager.js